import { Comparable, GridItemDef, KeyFrame, Trackable } from '@stylehaven/components';

export class KeyframeItem implements Comparable, Trackable, GridItemDef {
    public readonly keyframe: KeyFrame;
    public readonly keyframeIndex: number;
    public readonly typeIcon: string = 'file';

    constructor(keyframe: KeyFrame, index: number) {
        this.keyframe = keyframe;
        this.keyframeIndex = index;
    }

    equals(other: any): boolean {
        if (!(other instanceof KeyframeItem)) {
            return false;
        }

        return this.keyframe.PreviewImagePath === other.keyframe.PreviewImagePath;
    }

    trackBy(): string {
        return this.keyframe.PreviewImagePath;
    }

    getTitle(): string {
        return '';
    }

    getThumbnailUrl(): string {
        return this.keyframe.ThumbnailImagePath;
    }

    getDetailUrl() {
        return '';
    }

    getRecordStatus() {
        return '';
    }

    getRecordType() {
        return 'page';
    }

    getType(): string {
        return 'page';
    }

    getMediaHavenType(): string {
        return this.getType();
    }

    getTypeIconName(): string {
        return 'file';
    }

    hasFailedJobs(): boolean {
        return false;
    }

    hasErrors(): boolean {
        return false;
    }
}
